<template>
  <div class="certificateItem">
    <v-card>
      <v-card-title>{{ certificate.title }}</v-card-title>
      <v-card-subtitle>{{ certificate.subTitle }}</v-card-subtitle>

      <v-list dense>
        <v-list-item v-for="msg in certificate.messagesNotAvailable" :key="msg">
          <v-list-item-icon>
            <v-icon color="error" left>mdi-alert-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ msg }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-card-actions :hidden="!isShowButtons()">
        <v-btn :hidden="!isSurveyAllowed(survey)" class="surveyBtn"
          :class="{ surveyMandatory: survey.isMandatory, surveyComplete: survey.isCompleted }"
          v-for="survey in certificate.surveys" :key="survey.surveyCode" outlined @click="survey_click(survey)">{{
            survey.title }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn :hidden="certificate.isHideCertificateButton" :disabled="!certificate.isAvailable"
          @click="certificate_click" outlined color="primary">
          <v-icon left>mdi-printer</v-icon>Certificate
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import store from "@/store/index.js";
export default {
  name: "CertificateItem",
  props: { certificate: Object },
  methods: {
    certificate_click(cert) {
      var url = `${store.state.apiUri}/detail/index/${store.state.eventCode}/${store.state.configCode}/${this.certificate.certificateCode}/${store.state.barcode}/${store.state.barcodeHash}`;
      if (this.certificate.isOpenInNewTab === true) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          name: "CertificateDetail",
          params: { certificateUrl: url },
        });
      }
    },

    survey_click(survey) {
      window.location = survey.url;
    },

    isShowButtons() {
      let isShowCertificate = this.certificate.isHideCertificateButton === false && this.certificate.isAvailable === true;

      let isShowSurveys = false;
      let me = this;
      this.certificate.surveys.forEach(s => {
        if (me.isSurveyAllowed(s) === true) {
          isShowSurveys = true;
        }
      });

      return isShowCertificate === true || isShowSurveys === true;      
    },

    isSurveyAllowed(survey) {
      if (!this.certificate.areSurveysAvailable) {
        return false;
      }
      return !(survey.isCompleted && !survey.allowMultipleEntries);
    },
  },
  mounted() { },
};
</script>

<style lang="scss" scoped>
.certificateItem {
  .surveyBtn {
    color: purple;

    &.surveyMandatory {
      color: red;
    }

    &.surveyComplete {
      color: green;
    }
  }

  width: 75%;
  min-width: 800px;
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 20px;
}
</style>